import { type QueryHookOptions, useQuery } from "@apollo/client";
import { CollectionOptionsQuery } from "../graphql/queries";
import type {
  CollectionOptionsQueryType,
  CollectionOptionsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useCollectionOptionsQuery = (
  options?: QueryHookOptions<
    CollectionOptionsQueryType,
    CollectionOptionsQueryVariablesType
  >
) => {
  return useQuery<
    CollectionOptionsQueryType,
    CollectionOptionsQueryVariablesType
  >(CollectionOptionsQuery, options);
};
